module.exports = __webpack_public_path__ + "static/media/Bin.5c785ab2.svg";